import React from 'react'
import SomethingWentWrongImg from '../../assets/images/Something_went_wrong.svg'
import Button from '../buttons/Button'
import { useSelector } from 'react-redux';
import { useFetchFonts, useFetchFontsWithMd5Hash } from '../../services/fontListService';
import { useUploadImage } from '../../services/uploadImageService';
import { useGenerateImages } from '../../services/imageService';

const SomethingWentWrongFontError = () => {
    const { fetchFonts } = useFetchFonts();
    const uploadImage = useUploadImage();
    const generateImages = useGenerateImages();
    const { fetchFontsWithMd5FormUrl } = useFetchFontsWithMd5Hash();




    const { prompt, originalUserPrompt } = useSelector((state) => state.prompt);
    const { isFontError, errorFontListMessage, lastPayloadForUrlMd5, lastPayloadForUrlFontFamlily, lastPayloadForInventories, lastPayloadForUrlFontName } = useSelector((state) => state.fontList);
    const { uploadedImage, uploadImageError } = useSelector((state) => state.uploadImage);
    const { userData } = useSelector((state) => state.auth);



    const handleTryAgainButton = async () => {
        let promptId = "new";
        if (isFontError || errorFontListMessage === 'Failed to fetch fonts from md5') {
            let fonts = {
                md5: lastPayloadForUrlMd5,
                font_name: lastPayloadForUrlFontName,
                family_url: lastPayloadForUrlFontFamlily || "",
                foundry_name: '',
            }
            const sementicFont = await fetchFonts(prompt || originalUserPrompt, lastPayloadForInventories);
            if (!sementicFont) return;
            if (userData?.termsAndConditions === false || userData === null) return
            await generateImages(promptId, prompt, fonts);
        }
        else if (uploadImageError) {
            await uploadImage(prompt, uploadedImage.base64String, uploadedImage.fileName);
        } else {
            await fetchFonts(prompt, lastPayloadForInventories);
        }
    }

    return (
        <div className='h-[calc(100vh-80px)] w-full'>
            <div className='h-full flexCenter flex-col gap-[48px]'>
                <img src={SomethingWentWrongImg} alt="server busy" className='h-[35%] w-[35%] xl:h-[275px] xl:w-[328px]' />
                <div className='h-[208px] max-w-[876px]  text-center flexCenter flex-col gap-[24px]'>
                    <h1 className='text-[#313945] font-helveticaDisp-Bold text-[40px] font-[700] leading-[48px] tracking-[-0.02em]'>Uh-oh! Something went wrong.</h1>
                    <p className='text-[23px] text-secondary'>We're on it—let's see what we can do to fix this and get you that awesome result, feel free to go back or try again.</p>
                    <Button onClick={handleTryAgainButton} label='Try again' className="w-fit bg-pink-primary hover:bg-pink-dark text-white px-[48px] " />
                </div>

            </div>
        </div>
    )
}

export default SomethingWentWrongFontError